<div class="ft-qr-reader-wrap">

  <div #formFieldContainer class="qr-reader-class component-wrap" style="margin-bottom: 10px;">
    <mat-label
      #labelContainer
      (click)="toggleTooltip(tooltip)"
      class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ft-label"
      [title]="componentDefinition?.label">
        {{componentDefinition?.label}}
    </mat-label>

      <div class="labelToolTipContainer"
        #tooltip="matTooltip"
        matTooltip="{{componentDefinition.label}}"
        [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
      </div>

      <button style="margin-top: 6px;" type="button" class="q-r-code-btn" mat-stroked-button color="primary" *ngIf="showVideo" (click)="scanQRCode()" [disabled]="disabled">
        <mat-icon style="display: flex;">
          <svg style="width:24px;" viewBox="0 0 24 24">
            <path fill="#000000"
                  d="M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z"/>
          </svg>
        </mat-icon>
        <span *ngIf="showVideo">Scan Code</span>
      </button>

      <div class="qr-code-reader-id" [hidden]="showVideo">
        <!-- Video -->
        <div class="video-row">
          <video class="video" id="video" #video autoplay playsinline></video>
        </div>
        <!-- Canvas -->
        <div style="display: none;grid-area: 1/1/2/2;">
          <canvas class="video" id="canvas" #canvas></canvas>
        </div>
        <div class="btn-capture-wrap">
          <button type="button" mat-fab color="primary" aria-label="Capture Qr Code"
          *ngIf="!showVideo"  title="Capture Qr Code" class="capture-button-class" (click)="checkImage()">
            <mat-icon>photo_camera</mat-icon>
          </button>

        </div>

      </div>
      <ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
    </div>

    <mat-form-field *ngIf="document[fieldName]" class="url-class">
      <mat-label>Result</mat-label>
      <input matInput placeholder="Qr String Result"
            [name]="componentDefinition?.name"
            [readonly]="disabled"
            (ngModelChange)="valueChanged($event)"
            [(ngModel)]="document[fieldName]">
      <button type="button" *ngIf="document[fieldName]" (click)="qResultOpenLink()" mat-icon-button matSuffix aria-label="open_in_browser"
              class="ft-url-icon">
        <mat-icon color="primary" style="font-size: 24px;">open_in_browser</mat-icon>
      </button>

    </mat-form-field>

</div>